import React, { Component } from "react";
import axios from 'axios'
import ReactPaginate from 'react-paginate';
import { BASEURL } from "../Config"
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { Link } from 'react-router-dom';
import { getBookInfo, getChapterInfo } from "../modules/reducers";
import { getTopicInfo } from '../modules/actions';
import { connect } from "react-redux";
import { withRouter, NavLink } from 'react-router-dom';
import { compose } from "redux";
import swal from "sweetalert";

class Topics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            slice: [],
            perPage: 10,
            currentPage: 0,
            editableRow: null,
            tname: "",
            id: ""
        }
        this.handlePageClick = this
            .handlePageClick
            .bind(this);
    }

    receivedData() {
        let cid = this.props.history.location.state ? this.props.history.location.state.cid : this.props.chapter._id;
        axios
            .get(`${BASEURL}/api/v1/topics/fetchTopics/${this.props.book._id}?cid=${cid}`)
            .then(res => {
                // console.log('res.data', res.data);
                const data = [];
                for (let i = 0; i < res.data.length; i++) {
                    if (!res.data[i].isDeleted) {
                        data.push(res.data[i]);
                    }
                }
                console.log('data', data);
                const slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
                console.log('slice', slice);
                this.setState({
                    pageCount: Math.ceil(data.length / this.state.perPage),
                    slice
                })
            });
    }
    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;

        this.setState({
            currentPage: selectedPage,
            offset: offset
        }, () => {
            this.receivedData()
        });

    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        })
    }

    handleUpdateTopic() {
        let data = {};
        data.id = this.state.id;
        data.tname = this.state.tname;

        console.log('update data', data)
        axios.put(`${BASEURL}/api/v1/topics/update`, data)
            .then(res => {
                if (res.status === 200) {
                    console.log('res.data', res.data);
                    this.receivedData()
                }
            })
            .catch((err) => {
                console.log('Update topic Error', err);
            })
    }

    componentDidMount() {
        this.receivedData()
        console.log('chapter', this.props.chapter)
    }

    handleOnAddQuestions = (tid) => {
        this.props.dispatch(getTopicInfo(tid));
        this.props.history.push({
            pathname: '/addQuestions',
            state: { tid: tid }
        });
    }

    handleOnViewQuestions = (tid) => {
        this.props.dispatch(getTopicInfo(tid));
        this.props.history.push({
            pathname: '/questions',
            state: { tid: tid }
        });
    }

    handleOnDeleteTopic(id) {
        swal({
            title: "Are you sure?",
            text: "All the questions related to this topic will be deleted!",
            icon: "warning",
            buttons: [
              'No',
              'Yes'
            ],
            dangerMode: true,
          }).then(function(isConfirm) {
            if (isConfirm) {
                let obj = {};
                obj.id = id;
                obj.isDeleted = true;
                console.log('obj');
                // swal('Success', 'Topic Deleted Successfully', 'success')
                axios.post(`${BASEURL}/api/v1/topics/updateDeleteStatus`, obj)
                .then(res => {
                    if(res.status === 200) {
                        swal('Success', 'Topic Deleted Successfully', 'success')
                        .then(function() {
                            window.location = "topics";
                        })
                    } else {
                        swal('Error', 'Error in deleting the topic', 'error')
                        .then(function() {
                            window.location = "topics";
                        })
                    }
                })
            }
          });
    }


    render() {
        return (

            <div id="wrapper">
                <Sidebar act="books" />
                {/* Content Wrapper */}
                <div className="content-page">
                    {/* Main Content */}
                    <div className="content">
                        <Topbar act="Topics" breadcrumbItems={['Test Generator', { label: 'Books', path: '/books' }, { label: 'Chapters', path: '/chapters' }, 'View Topics']} />
                        {/* container */}
                        {/* content */}
                        <div className="container-fluid main-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card main-card">
                                        <div className="card-body">
                                            <h4 className="page-title">Book name: {this.props.book.name}</h4>
                                            <h4 className="page-title">Chapter name: {this.props.chapter.cname}</h4>
                                            <Link className="btn btn-primary brn-sm"
                                                to={{
                                                    pathname: "/addTopics"
                                                }}
                                            > <i className="mdi mdi-plus-circle" /> Add Topics</Link>
                                            <table className="table table-centered mb-0 mt-2">
                                                <thead>
                                                    <tr>
                                                        <th>Name of the Topic</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.slice.length === 0 ?
                                                        <tr className="text-center"><td colSpan="2">No Topics added</td></tr> :
                                                        <>
                                                            {this.state.slice.map((data, idx) => (
                                                                <tr>
                                                                    <td className="table-user">
                                                                        {this.state.editableRow === idx ?
                                                                            <input type="text" id="topicname" className="form-control" onChange={(e) => this.handleChange(e, data._id)}
                                                                                name="tname" placeholder="Enter Topic Name"
                                                                                defaultValue={data.tname} disabled={this.state.editableRow !== idx} /> :
                                                                            <input type="text" id="topicname" className="form-control" onChange={(e) => this.handleChange(e, data._id)}
                                                                                name="tname" placeholder="Enter Topic Name"
                                                                                value={data.tname} disabled={this.state.editableRow !== idx} />
                                                                        }
                                                                    </td>
                                                                    <td >
                                                                        {this.state.editableRow === idx ?
                                                                            <button className="btn btn-primary brn-sm table_Action_btns" onClick={() => { this.handleUpdateTopic(); this.setState({ editableRow: null }); }}><i className="mdi mdi-content-save-outline" />save</button> :
                                                                            <button className="btn"
                                                                                onClick={() => { this.setState({ editableRow: idx, id: data._id, tname: data.tname }) }}>
                                                                                <i className="mdi mdi-pencil" /></button>}
                                                                        <button className="btn" onClick={() => this.handleOnDeleteTopic(data._id)}> <i className="mdi mdi-delete" /></button>
                                                                        <button className="btn btn-success brn-sm table_Action_btns"
                                                                            onClick={() => this.handleOnAddQuestions(data._id)}
                                                                        > <i className="mdi mdi-plus-circle" /> Questions</button>
                                                                        <button className="btn btn-warning brn-sm"
                                                                            onClick={() => this.handleOnViewQuestions(data._id)}
                                                                        > <i className="mdi mdi-eye-circle" /> Questions</button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                    }
                                                </tbody>
                                            </table>

                                            <div className="pagination-div">
                                                <ReactPaginate
                                                    previousLabel={"Previous"}
                                                    nextLabel={"Next"}
                                                    breakLabel={"..."}
                                                    breakClassName={"break-me"}
                                                    pageCount={this.state.pageCount}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={this.handlePageClick}
                                                    containerClassName={"pagination"}
                                                    subContainerClassName={"pages pagination"}
                                                    activeClassName={"active"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* End of Main Content */}
                        <Footer />
                    </div>
                    {/* End of Content Wrapper */}
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        book: getBookInfo(state),
        chapter: getChapterInfo(state)
    }
}

export default compose(withRouter, connect(mapStateToProps))(Topics);